module.exports = __webpack_public_path__ + "static/img/1.101238b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/1.png
// module id = qXTP
// module chunks = 0